import styled from "styled-components";

import { Form, FormLinks } from "../../shared/styles/Form.styles";

export const ResetPasswordForm = styled(Form)``;
export const ResetPasswordFormLinks = styled(FormLinks)``;
